@if (table.length > 0) {
  <p-treeTable
    #tt
    sortField="name"
    filterMode="lenient"
    [value]="table"
    [columns]="cols"
    [scrollable]="true"
    [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="caption">
      <div class="flex justify-content-end align-items-center">
        <div class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            class="border-round-3xl"
            pInputText
            #searchInput
            type="text"
            (input)="tt.filterGlobal(searchInput.value, 'contains')"
            placeholder="durchsuchen ..." />
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowNode
      let-rowData="rowData"
      let-columns="columns">
      <tr [ttRow]="rowNode">
        <td *ngFor="let col of columns; let i = index">
          <div class="flex align-items-center">
            @switch (i) {
              @case (0) {
                <p-treeTableToggler [rowNode]="rowNode" />
                <span>{{ rowData[col.field] }} </span>
              }
              @case (3) {
                @if (i === 3 && rowData.dataInternal) {
                  <div class="flex gap-2">
                    <p-chip
                      [label]="rowData.dataInternal || '0'"
                      icon="fas fa-house-user"></p-chip>
                    <p-chip
                      [label]="rowData.dataExternal || '0'"
                      icon="fas fa-globe-europe"></p-chip>
                  </div>
                } @else if (rowData.data) {
                  <span>{{ rowData[col.field] }}</span>
                } @else if (!rowData.data) {
                  <i class="text-color-secondary font-italic"
                    >keine Daten hinterlegt</i
                  >
                }
              }
              @default {
                <span>{{ rowData[col.field] }}</span>
              }
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
}
